// assets
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { IconFileAnalytics } from '@tabler/icons';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import WorkIcon from '@mui/icons-material/Work';
import UploadFileIcon from '@mui/icons-material/UploadFile';
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const hanhsinhs = {
    id: 'hanh-sinh',
    title: 'Hạnh sinh',
    type: 'group',
    children: [
        // Mọi hạnh sinh có mã HS đều nộp được, không lọc theo danh sách nào — nên mục này
        // KHÔNG cần MenuList giấu đi như mục Đăng ký thực tập bên dưới.
        {
            id: 'hanh-sinh-ke-hoach-thuc-tap',
            title: 'Nộp kế hoạch thực tập',
            type: 'item',
            url: '/hanh-sinh-ke-hoach-thuc-tap',
            icon: UploadFileIcon,
            breadcrumbs: false
        },
        // Chỉ hiện cho hạnh sinh có trong danh sách Trung Minh — MenuList lọc theo store
        // dangKyThucTap.phieu (id này được nhắc tới ở đó, đổi tên thì đổi cả hai nơi).
        {
            id: 'hanh-sinh-dang-ky-thuc-tap',
            title: 'Đăng ký thực tập',
            type: 'item',
            url: '/hanh-sinh-dang-ky-thuc-tap',
            icon: WorkIcon,
            breadcrumbs: false
        },
        {
            id: 'hanh-sinh-bao-cao-tu-tap',
            title: 'Báo cáo tu tập',
            type: 'item',
            url: '/hanh-sinh-bao-cao-tu-tap',
            icon: AutoStoriesIcon,
            breadcrumbs: false
        },
        {
            id: 'hanh-sinh-ket-qua-tu-tap',
            title: 'Kết quả tu tập',
            type: 'item',
            url: '/hanh-sinh-ket-qua-tu-tap',
            icon: IconFileAnalytics,
            breadcrumbs: false
        },
        {
            id: 'hanh-sinh-xuat-ket-qua-tu-tap',
            title: 'Xuất kết quả tu tập',
            type: 'item',
            url: '/hanh-sinh-xuat-ket-qua-tu-tap',
            icon: PlagiarismIcon,
            breadcrumbs: false
        },
        {
            id: 'hanh-sinh-ket-qua-tu-hoc',
            title: 'Tu học nhóm',
            type: 'item',
            url: '/hanh-sinh-ket-qua-tu-hoc',
            icon: Diversity3Icon,
            breadcrumbs: false
        },
        {
            id: 'diem-kiem-tra',
            title: 'Kết quả tu học & tu tập',
            type: 'item',
            url: '/diem-kiem-tra',
            icon: DomainVerificationIcon,
            breadcrumbs: false
        }
    ]
};

export default hanhsinhs;
